var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTumblr = function SvgTumblr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001935",
    d: "M15.225 24c-3.6 0-6.3-1.85-6.3-6.3v-7.1h-3.3V6.75c3.6-.95 5.1-4.05 5.3-6.75h3.75v6.1h4.35v4.5h-4.35v6.2c0 1.85.95 2.5 2.45 2.5h2.1V24z"
  })));
};
export default SvgTumblr;